import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';

import { BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { faInfoCircle } from '@fortawesome/pro-light-svg-icons';
import { CorporateAccountService, EventService, GeneralService, PaymentService } from '@clooper/core';
import { Subject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
@Component({
  selector: 'app-booking-limits',
  templateUrl: './booking-limits.component.html',
  styleUrls: ['./booking-limits.component.scss'],
})
export class BookingLimitsComponent implements OnInit {
  @Input() loading = false;
limitform!: FormGroup
  icons = {
    info: faInfoCircle,
  };

  businessId: any;
  public onClose: Subject<boolean>;
  currencies: any;
  isEdit: boolean = false;

  constructor(
    public bsModalRef: BsModalService,
    private bookingLimitService: CorporateAccountService,
    private options: ModalOptions,
    private toastr: ToastrService,
    private gs: GeneralService,
    private fb: FormBuilder,
    private service: PaymentService,

  ) {
  }

  ngOnInit(): void {
    this.getCurrencies()

    this.businessId = this.options.initialState?.businessId;

    this.onClose = new Subject();
    if (this.options.initialState?.edit && this.options.initialState?.limit) {
      this.isEdit = true;

      const {limit, service_type, currency} = this.options.initialState.limit as any;
        this.limitform = this.fb.group({
          limitValue: [limit, Validators.required],
          service_type: [service_type, Validators.required],
          currency: [currency],
        });
      } else {
        this.limitform = this.fb.group({
          limitValue: ['', Validators.required],
          service_type: ['', Validators.required],
          currency: [''],
        });
      }
  }

  getCurrencies() {
    this.service.getCurrencies().subscribe((res: any) => {
      this.currencies = res.data
    })
  }


  handleAddLimit() {
    if (this.limitform.invalid) {
      return;
    }

    const { limitValue, service_type, currency } = this.limitform.value;
    this.loading = true;

    const payload = {
      service_type,
      limit: limitValue,
      currency: currency || "GBP",
      business: this.businessId,
    };

    if (this.options.initialState?.edit) {
      const {_id} = this.options.initialState.limit as any;
      // Update existing limit
      this.bookingLimitService.updateBookingLimit(_id, payload).subscribe(
        (res: any) => {
          this.loading = false;
          this.toastr.success(res.message);
          this.onClose.next(true);
          this.bsModalRef?.hide();
        },
        (err) => {
          this.toastr.error(this.gs.getErrMsg(err));
          this.loading = false;
        }
      );
    } else {
      // Create new limit
      this.bookingLimitService.createBookingLimit(payload).subscribe(
        (res: any) => {
          this.loading = false;
          this.toastr.success(res.message);
          this.onClose.next(true);
          this.bsModalRef?.hide();
        },
        (err) => {
          this.toastr.error(this.gs.getErrMsg(err));
          this.loading = false;
        }
      );
    }



}

}
